import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PopoverListItem from 'rp-react-common/PopoverListItem';
import HeaderCell from './HeaderCell';

const columns = [{
    className: 'tn-napsTable__naps tn-napsTable__naps_header',
    name: 'naps',
    text: 'Today\'s naps',
}, {
    className: 'tn-napsTable__time',
    name: 'time',
    text: 'Time',
}, {
    className: 'tn-napsTable__crs',
    name: 'crs',
    text: 'Crs',
}, {
    className: 'tn-napsTable__tipster tn-napsTable__tipster_header',
    name: 'tipster',
    text: 'Tipster',
}, {
    className: 'tn-napsTable__levelStakes',
    name: 'stakes',
    text: 'Level stakes',
}];

class NapsTableHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopoverVisible: false,
        };
        this.columns = columns.map(item => ({
            ...item,
            onClick: this.onSort.bind(this, item.name),
        }));
        this.handleClick = this.handleClick.bind(this);
        this.onPopoverCellSetRef = this.onPopoverCellSetRef.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside.bind(this), true);
        document.addEventListener('touchstart', this.handleClickOutside.bind(this), true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
        document.removeEventListener('touchend', this.handleClickOutside, true);
    }

    onSort(column) {
        this.props.onSort(column);
    }

    onPopoverCellSetRef(node) {
        this.node = node;
    }

    handleClick() {
        this.setState({
            isPopoverVisible: !this.state.isPopoverVisible,
        });
    }

    handleClickOutside(event) {
        if (this.state.isPopoverVisible && !this.node.contains(event.target)) {
            this.setState({
                isPopoverVisible: false,
            });
        }
    }

    render() {
        const {
            sortedBy,
        } = this.props;
        return (
            <div className="tn-napsTable__header ui-table__head">
                <div className="tn-napsTable__main">
                    <HeaderCell
                        className={classNames(
                            'tn-napsTable__napsTipster_header',
                            { 'tn-napsTable__popoverWrapper': this.state.isPopoverVisible },
                        )}
                        isSorted={sortedBy === 'naps' || sortedBy === 'tipster'}
                        onClick={this.handleClick}
                        refCallback={this.onPopoverCellSetRef}
                    >
                        {"Today's naps / Tipster"}
                        {
                            this.state.isPopoverVisible
                                ? (
                                    <div
                                        className={classNames(
                                            'tn-napsTable__popover',
                                            'ui-popover',
                                            'ui-popover_customised',
                                        )}
                                    >
                                        <PopoverListItem
                                            isSelected={sortedBy === 'naps'}
                                            onSelect={() => this.onSort('naps')}
                                            text="Today's naps"
                                        />
                                        <PopoverListItem
                                            isSelected={sortedBy === 'tipster'}
                                            onSelect={() => this.onSort('tipster')}
                                            text="Tipster"
                                        />
                                    </div>
                                )
                                : null
                        }
                    </HeaderCell>
                    {
                        this.columns.map(({ className, name, text, onClick }) => (
                            <HeaderCell
                                className={className}
                                isSorted={sortedBy === name}
                                text={text}
                                onClick={onClick}
                                key={name}
                            />
                        ))
                    }
                </div>
                <HeaderCell
                    className="tn-napsTable__odds"
                    isSorted={sortedBy === 'odds'}
                    text={'Odds'}
                    onClick={() => this.onSort('odds')}
                />
            </div>
        );
    }
}

NapsTableHeader.propTypes = {
    sortedBy: PropTypes.string.isRequired,
    onSort: PropTypes.func.isRequired,
};

export default NapsTableHeader;



// WEBPACK FOOTER //
// ./src/js/napsTable/NapsTableHeader.js